export default __webpack_public_path__ + "static/reports_codebook-664e551d600323ade507ca9470227f84.pdf";